import { Box, Divider, Typography } from "@mui/material";
import { Link } from "react-router-dom";

function generateSubGenreLst() {
  const components = [];

  for (let i = 0; i < 10; i++) {
    components.push(`Component ${i}`);
  }

  return components;
}

const lList = [
  "ヘルプ・お問い合わせ",
  "食べログについて",
  "口コミ・ランキングに対する取り組み",
  "飲食店・飲食企業様向けサービスについて",
  "広告（メーカー・団体様等向け）について",
  "機能改善要望",
  "口コミガイドライン",
  "食べログプレミアム",
  "食べログプレミアム無料クーポン",
  "利用規約",
  "外部送信（オプトアウト）",
  "個人情報保護方針",
  "採用情報",
  "企業情報",
  "サイトマップ",
  "キーワード一覧",
];

export function FooterSection() {
  // const lList = generateSubGenreLst();
  return (
    <Box bgcolor="#faf8f5" textAlign="center" overflow="auto">
      <Box
        px="7%"
        display="flex"
        flexWrap="wrap"
        justifyContent="center"
      >
        {lList.map((item, index) => (
          <Box key={index}>
            <Box m={1} p={1} borderColor="divider">
              <Typography
                component={Link}
                to=""
                textTransform="none"
                fontWeight="bold"
                color="#0060df"
                variant="subtitle2"
                sx={{
                  textDecoration: "none",
                  "&:hover": {
                    textDecoration: "underline",
                  },
                }}
              >
                {item}
              </Typography>
            </Box>
            {/* {index !== lList.length - 1 && <Divider orientation="vertical" />} */}
          </Box>
        ))}
      </Box>
    </Box>
  );
}
